import actions from "@/shared/actions";

// 仅支持当子系统触发开始工作将工作状态为在线时，调用该方法触发关闭弹框标识
export const dealCurrentStatus = (status: any) => {
  actions.setGlobalState({changeWorkbenchStatus: 'complete'});
  // if(status === 100) {
  //   actions.setGlobalState({workbenchControlCloseFlag: 100});
  // } else {
  //   actions.setGlobalState({workbenchControlCloseFlag: 0});
  //   actions.setGlobalState({currentTicketStatus: status});
  // }
}

export const deleteTicketState = () => {
  actions.setGlobalState({changeWorkbenchStatus: 'wait'});
  // actions.setGlobalState({workbenchControlCloseFlag: 0});
  // actions.setGlobalState({currentTicketStatus: 0});
}